var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 22.1706c0 .5063.31818.8294.79032.8294h19.36808c.4618 0 .8416-.3878.8416-.8724 0-.4955-.3798-.8833-.8416-.8833h-18.20825c-.20528 0-.26687-.0646-.26687-.28v-4.4484l4.04399-4.3407c.09238-.097.18475-.1401.26687-.1401.08211 0 .17448.0431.25659.1401l3.54107 3.8129c.4208.4631.8724.6786 1.3343.6786.4721 0 .9032-.2155 1.3446-.6786l3.9721-4.1899 1.5704 1.6587c.3695.3878.8622.1508 1.0059-.3985l1.4369-5.9779c.1232-.50624-.2976-.91553-.7595-.78628l-5.6862 1.50793c-.5235.1508-.7493.65703-.3798 1.04479l1.5704 1.64796-3.8079 4.0607c-.0821.0861-.1848.1292-.2669.1292s-.1745-.0431-.2566-.14l-3.54105-3.8129c-.43109-.4632-.87244-.6786-1.33431-.6786-.47215 0-.8827.2046-1.34458.6786l-2.96628 3.1666v-9.01528c0-.48469-.3695-.88322-.84164-.88322s-.84164.39853-.84164.88322z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.21466312.svg";
export { ForwardRef as ReactComponent };